import { gql, useMutation } from '@apollo/client';
import { Mutation, MutationValidateVoucherArgs } from '../types/types';

export const validateVoucherMutation = gql`
  mutation ValidateVoucher($offerId: String!, $voucherCode: String!) {
    validateVoucher(offerId: $offerId, voucherCode: $voucherCode) {
      status
      message
      voucherDescription
      voucherLabels
      voucherValue
    }
  }
`;

export function useValidateVoucher() {
  return useMutation<Pick<Mutation, 'validateVoucher'>, MutationValidateVoucherArgs>(validateVoucherMutation);
}
